import Image from "next/image";
import { Button } from "@/components/ui/button";

const providers = [
  {
    id: "google",
    label: "Google",
    logo: "/third-party-logos/google.svg",
    alt: "Google logo",
  },
  {
    id: "github",
    label: "GitHub",
    logo: "/third-party-logos/github.svg",
    alt: "GitHub logo",
  },
] as const;

type AuthSocialButtonsProps = {
  onGoogle: () => void;
  onGithub: () => void;
  disabled?: boolean;
};

const AuthSocialButtons = ({
  onGoogle,
  onGithub,
  disabled,
}: AuthSocialButtonsProps) => {
  const clickHandlers = {
    google: onGoogle,
    github: onGithub,
  } satisfies Record<(typeof providers)[number]["id"], () => void>;

  const getProviderLogo = (provider: (typeof providers)[number]) => {
    // Always use dark GitHub logo — these buttons only appear on light-themed landing/auth pages
    return provider.logo;
  };

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {providers.map((provider) => (
        <Button
          key={provider.id}
          type="button"
          variant="outline"
          disabled={disabled}
          className="h-12 rounded-3xl border-border/60 bg-card text-sm font-semibold text-foreground transition hover:-translate-y-0.5 hover:shadow-[0_22px_50px_-32px_rgba(17,24,39,0.35)]"
          onClick={clickHandlers[provider.id]}
        >
          <span className="mr-2 inline-flex size-8 items-center justify-center rounded-full bg-muted">
            <Image
              src={getProviderLogo(provider)}
              alt={provider.alt}
              width={20}
              height={20}
            />
          </span>
          {provider.label}
        </Button>
      ))}
    </div>
  );
};

export default AuthSocialButtons;
